export enum WidgetType {
    month = 1,
    week,
    schedule
}

export class CalendarViewCache {
    public widget: WidgetType;
    public month_title: string;
    public current_date: Date;
}